import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { PageVariable, VariableValues } from '@/types'
import { defaultValues } from '@/lib/variables'

export const useVariablesStore = defineStore('variables', () => {
  const values = ref<Record<string, VariableValues>>({})

  const putVariables = (pageId: string, variables: PageVariable[]) => {
    const defaults = defaultValues(variables)
    const current = values.value[pageId] ?? {}
    const next: VariableValues = {}
    for (const v of variables) next[v.name] = current[v.name] ?? defaults[v.name] ?? []
    values.value = { ...values.value, [pageId]: next }
  }

  const putVariable = (pageId: string, name: string, picked: string[]) => {
    values.value = { ...values.value, [pageId]: { ...(values.value[pageId] ?? {}), [name]: picked } }
  }

  const getVariableValues = (pageId: string | null | undefined): VariableValues =>
    (pageId ? values.value[pageId] : undefined) ?? {}

  return { values, putVariables, putVariable, getVariableValues }
})
